import portsApi from '@/framework/ports/portsApi';
import { AssemblerContext } from '@/types/environment';

const Window = {
  postMessage: (url: string, target: string): void => {
    portsApi.invoke('Window.postMessage', [url, target]);
  },
  getInnerWidth: (): Promise<number> => portsApi.invoke('Window.getInnerWidth'),
  openUsabilla: (): void => {
    portsApi.invoke('Window.openUsabilla');
  },
  open: (url: string, target: string): void => {
    portsApi.invoke('Window.open', [url, target]);
  },
  openSite: (url: string, target: string): void => {
    portsApi.invoke('Window.openSite', [url, target]);
  },
  redirectToUrl: (url: string): void => {
    portsApi.invoke('Window.redirectToUrl', [url]);
  },
  handleOpenInIframe: (): void => {
    portsApi.invoke('Window.handleOpenInIframe');
  },
  getInitialPresenterLayout: (): Promise<any> =>
    portsApi.invoke('Window.getInitialPresenterLayout'),
  getAssemblerContext: (): Promise<AssemblerContext> =>
    portsApi.invoke('Window.getAssemblerContext'),
};

export default Window;
